import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { MagnifyingGlass, Globe } from '@phosphor-icons/react';
import NotificationBell from '../NotificationBell';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '../ui/dropdown-menu';

export function Header({ title }) {
  const { language, setLanguage, t } = useLanguage();

  return (
    <header className="sticky top-0 z-20 glass border-b border-[#242E42]/50">
      <div className="flex items-center justify-between h-16 px-4 lg:px-6">
        {/* Title - Mobile has padding for menu button */}
        <div className="lg:ml-0 ml-12">
          <h1 className="font-['Outfit'] text-xl font-semibold text-[#F3F4F6]">{title}</h1>
        </div>

        {/* Right Section */}
        <div className="flex items-center gap-2">
          {/* Search */}
          <button
            className="p-2 rounded-lg text-[#9CA3AF] hover:text-[#F3F4F6] hover:bg-[#1E2636] transition-all"
            data-testid="header-search"
          >
            <MagnifyingGlass className="w-5 h-5" />
          </button>

          {/* Notifications - Persistent Bell */}
          <NotificationBell />

          {/* Language Selector */}
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <button
                className="flex items-center gap-2 px-3 py-2 rounded-lg text-[#9CA3AF] hover:text-[#F3F4F6] hover:bg-[#1E2636] transition-all"
                data-testid="language-selector"
              >
                <Globe className="w-5 h-5" />
                <span className="text-sm font-medium uppercase">{language}</span>
              </button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="bg-[#151B26] border-[#242E42]">
              <DropdownMenuItem
                onClick={() => setLanguage('es')}
                className={`cursor-pointer ${language === 'es' ? 'text-[#E2B05E]' : 'text-[#F3F4F6]'}`}
                data-testid="lang-es"
              >
                <span className="mr-2">🇪🇸</span> Español
              </DropdownMenuItem>
              <DropdownMenuItem
                onClick={() => setLanguage('en')}
                className={`cursor-pointer ${language === 'en' ? 'text-[#E2B05E]' : 'text-[#F3F4F6]'}`}
                data-testid="lang-en"
              >
                <span className="mr-2">🇺🇸</span> English
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      </div>
    </header>
  );
}

export default Header;
